<script>
import { COURSE_STAGES } from "@/utils/constants.js";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "SelectCourseStage",
  props: {
    stage: {
      type: String,
      required: false,
      default: "no-stage",
    },
    categoryId: {
      type: [String, Number],
      required: false,
      default: null,
    },
  },
  emits: ["confirm"],
  data() {
    return {
      selectedStage: this.stage ?? "no-stage",
    };
  },
  watch: {
    stage(newVal) {
      if (newVal !== this.selectedStage) {
        this.selectedStage = newVal ?? "no-stage";
      }
    },
    selectedStage(newVal) {
      if (!this.isInModal && newVal) {
        this.$emit("confirm", newVal);
      }
    },
  },
  computed: {
    ...mapGetters(["stagedCategories"]),
    ...mapGetters("modals", ["modalFormComponent"]),
    selectedCategoryId() {
      return this.categoryId || this.modalFormComponent?.value;
    },
    selectedCategoryStages() {
      return this.stagedCategories.find(
        (category) => category.id === this.selectedCategoryId
      )?.stages;
    },
    courseStagesItems() {
      if (!this.selectedCategoryStages) return [];

      return this.selectedCategoryStages.map((stageKey) => ({
        key: stageKey,
        text: COURSE_STAGES[stageKey] || stageKey,
      }));
    },
    isInModal() {
      // Проверяем, используется ли компонент в модальном окне
      return !!this.modalFormComponent;
    },
  },
  methods: {
    ...mapActions(["request_stagedCategories"]),
    confirmStage() {
      this.$emit("confirm", this.selectedStage);
    },
  },
  async beforeMount() {
    await this.request_stagedCategories();
  },
};
</script>

<template>
  <v-card color="#f0f8f6" class="overflow-hidden rounded-xl">
    <div class="select-course-stage-wrapper">
      <v-select
        v-model="selectedStage"
        :items="courseStagesItems"
        label="Выберите этап курса"
        item-title="text"
        item-value="key"
        outlined
        dense
        hide-details
        :class="isInModal ? 'mb-4' : ''"
      />
      <v-btn
        v-if="isInModal"
        color="primary"
        @click="confirmStage"
        :disabled="!selectedStage"
        >Подтвердить</v-btn
      >
    </div>
  </v-card>
</template>

<style scoped lang="scss">
.select-course-stage-wrapper {
  width: 320px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 18px;
  text-align: center;
  padding: 20px;
}
</style>
